import { render, staticRenderFns } from "./CourseTitlePage.vue?vue&type=template&id=d4d975f4&scoped=true"
import script from "./CourseTitlePage.vue?vue&type=script&lang=js"
export * from "./CourseTitlePage.vue?vue&type=script&lang=js"
import style0 from "./CourseTitlePage.vue?vue&type=style&index=0&id=d4d975f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4d975f4",
  null
  
)

export default component.exports